
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { namespace } from "vuex-class";  
    import _ from 'underscore';

    import PageBase from "@/components/steps/PageBase.vue";   
    import OtherRequiredFormsList from "./components/OtherRequiredFormsList.vue";  
    import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue";
    import Tooltip from "@/components/survey/Tooltip.vue";
    import OtherFormList from "./components/OtherFormList.vue";
 
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    import "@/store/modules/common";
    const commonState = namespace("Common");

    import { documentTypesJsonInfoType, locationsInfoType } from '@/types/Common';
    import { stepInfoType } from "@/types/Application";
    import { FLA_Types } from '@/filters/applicationTypes';
    import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
    import { disclosureInformationFSDataInfoType } from '@/types/Application/FinancialStatement';

    @Component({
        components:{
            PageBase,
            OtherRequiredFormsList,
            GetHelpForPdf,
            Tooltip,
            OtherFormList
        }
    })    
    export default class OtherFile extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;

        @applicationState.State
        public id!: string;

        @applicationState.State
        public steps!: stepInfoType[];       

        @applicationState.State
        public currentStep!: number;

        @applicationState.State
        public stPgNo!: stepsAndPagesNumberInfoType; 

        @commonState.State
        public documentTypesJson!: documentTypesJsonInfoType[];

        @commonState.State
        public userLocation!: string;

        @commonState.State
        public locationsInfo!: locationsInfoType[];

        @applicationState.State
        public supportingDocuments!: any;      
        
        @applicationState.State
        public applicationLocation!: string;

        @applicationState.State
        public rejectedPathway!: boolean;
        
        @applicationState.State
        public rejectedFormsList!: any[];

        @applicationState.Action
        public UpdateSupportingDocuments!: (newSupportingDocuments) => void

        @applicationState.Action
        public UpdateGotoPrevStepPage!: () => void

        @applicationState.Action
        public UpdateGotoNextStepPage!: () => void

        @applicationState.Action
        public UpdatePageProgress!: (newPageProgress) => void        

        @applicationState.Action
        public UpdateCommonStepResults!: (newCommonStepResults) => void

        dataReady = false;
        error = "";

        showGetHelpForPDF = false;
        applicantLocation = {} as locationsInfoType; 
       
        submissionInProgress = false;
        
        supportingFile = null;
        selectedDocumentTypeState = true;
        selectedSupportingDocumentState = true;
        fileType = "";
        fileTypes: documentTypesJsonInfoType[] = [];
        requiredDocumentLists: documentTypesJsonInfoType[] = [];
        eFiling = false;       

        supportingDocumentFields = [
            { key: 'fileName', label: 'File Name',tdClass:'align-middle'},
            { key: 'fileType', label: 'File Type',tdClass:'align-middle'},
            { key: 'edit', thClass: 'd-none',tdClass:'align-middle'},
            { key: 'preview', thClass: 'd-none'}
        ];
             
        showTypeOfDocuments = false;
        submitEnable = true;
        currentPage=0;
        affIsExemptGuidedPathway = false;
        gaIsExemptGuidedPathway = false;
        apsIsExemptGuidedPathway = false;
        apspIsExemptGuidedPathway = false;
        csvIsExemptGuidedPathway = false;
        fsIsExemptGuidedPathway = false;
        requiresEfsp = false;
        requiresGaEfsp = false;
        requiresApsEfsp = false;
        requiresApspEfsp = false;
        requiresCsvEfsp = false;
        requiresFsEfsp = false;

        mounted(){

            this.dataReady = false;
            this.eFiling = false;            

            this.submitEnable =  true;
            const progress = 50;
            
            this.currentPage = Number(this.steps[this.currentStep].currentPage)
            this.UpdatePageProgress({ currentStep: this.currentStep, currentPage: this.currentPage, progress: progress });
            
            // Removed "REF" in otherFormFamilyTypes array as per https://jira.justice.gov.bc.ca/browse/PFCF-539
            const otherFormFamilyTypes = ["AFF", "APS", "APSP", "CSV", "CONA", "COR", "CIFT", "EFSP", "FF", "FS", "GA", "NCD", "NDT", "PASE", "NPR", "NLC", "NLP", "NP", "NLCR", "NLPR", "ORD", "RQS", "RFS", "RPS", "TRIS", "SUM", "SCH", "SDH", "REQ", "RFT"];
            const otherForms = FLA_Types.filter(type => otherFormFamilyTypes.includes(type.familyType));
            this.fileTypes = [];             
            
            for (const otherForm of otherForms){
                if (this.documentTypesJson.filter(docType => docType.type == otherForm.pdfType).length>0){
                    this.fileTypes.push({description: otherForm.fullName, type: otherForm.pdfType})
                }
            }

            this.extractInfo();
            this.determineRequiredGeneratedPdfs();
            
            this.dataReady = this.checkErrorOnPages();

            Vue.nextTick().then(()=>{
                const dropArea = document.getElementById('drop-area');
                if(dropArea){
                    dropArea.addEventListener('drop', this.handleFileDrop, false);
                    dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
                    dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
                    dropArea.addEventListener('dragover', this.dragPreventDefaults, false);                                          
                }
            });
           
            // const dropArea = document.getElementById('drop-area');
            // dropArea.addEventListener('drop', this.handleFileDrop, false);
            // dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
            // dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
            // dropArea.addEventListener('dragover', this.dragPreventDefaults, false);              
            
        }

        public dragPreventDefaults (e) {
            e.preventDefault()
            e.stopPropagation()
        }

        public handleFileDrop(e) {
            e.preventDefault()
            e.stopPropagation()
            const dt = e.dataTransfer
            const files = dt.files

            if (files && files[0]) 
            {
                this.supportingFile = files;                
                this.showTypeOfDocuments= true;
            }
        } 

        public uploadClicked(){
            const el = document.getElementById("inputfile");
            if(el) el.click();
        }

        public handleSelectedFile(event){

            event.preventDefault();
            event.stopPropagation();
            
            if (event.target.files && event.target.files[0]) 
            {
                this.supportingFile = event.target.files;
                
                this.showTypeOfDocuments= true;
            }
        }

        get isSubmissionReady(){ 
            
            if (this.requiredDocumentLists.length > 0){

                if (this.supportingDocuments.length == 0){
                    return false;
                } else {

                    const supportingDocumentTypes = this.supportingDocuments.map(doc => doc.documentType)

                    for (const doc of this.requiredDocumentLists){
                        
                        if (!supportingDocumentTypes.includes(doc.type)) return false;
                    }
                    return true;
                }

            } else {
                return true;
            }
            
        }
        
        public onPrev() {
            Vue.prototype.$UpdateGotoPrevStepPage()
        }

        public onNext() {
            Vue.prototype.$UpdateGotoNextStepPage()
        }        

        public onSubmit() {
            this.eFile();                       
        }

        public updateSubmittedPdf(){                        
            // Array.from(new Set(submittedPdfList.concat(supportingDocTypes)))
                        
            const submittedPdfList = this.requiredDocumentLists.map(form => form.type)
            // console.log(submittedPdfList)
            const stepResults = this.steps[this.stPgNo.OTHER._StepNo].result;
            const selectedFormInfoList = stepResults.completeOtherFormsSurvey?.data?.selectedFormInfoList? stepResults.completeOtherFormsSurvey.data.selectedFormInfoList: [];
            // console.log(selectedFormInfoList)
            for(const selectedForm of selectedFormInfoList){
                const pdfType = Vue.filter('getPathwayPdfType')(selectedForm.pathwayName)
                if (selectedForm.pathwayExists && selectedForm.pathwayState && !submittedPdfList.includes(pdfType) ){
                    submittedPdfList.push(pdfType)                                    
                }
            }  
                                
            // console.log(submittedPdfList)
            setTimeout(() => this.UpdateCommonStepResults({data:{'submittedPdfList':submittedPdfList}}) ,1);
            setTimeout(() => Vue.prototype.$saveChanges(), 50);
            
        }

        public determineRequiredGeneratedPdfs(){

            const stepResults = this.steps[this.stPgNo.OTHER._StepNo].result;
            const selectedFormInfoList = stepResults.completeOtherFormsSurvey?.data?.selectedFormInfoList? stepResults.completeOtherFormsSurvey.data.selectedFormInfoList: [];
            
            const updatedExistingOrders = [];
            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            for(const form of existingOrdersInfo){

                const pathwayInfo = selectedFormInfoList.filter(selectedForm => {if(Vue.filter('getPathwayPdfType')(selectedForm.pathwayName) == form.type) return form;})[0]
                if (pathwayInfo && !pathwayInfo.pathwayState){
                    form.doNotIncludePdf = true;                   
                }
                updatedExistingOrders.push(form)
            }   
            
            this.UpdateCommonStepResults({data:{'existingOrders':updatedExistingOrders}}); 
            Vue.nextTick(() => Vue.prototype.$saveChanges() );
        }

        public eFile() {
            this.submissionInProgress = true;  
            
            this.error = "";
            const bodyFormData = new FormData();
            const docType = []
            const lastFileTypes = this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:0
          
            let fileIndex = 0;
            for(const filetype of lastFileTypes){
            
                const tempSupportingDocs = this.supportingDocuments.filter(doc=>{return(doc.documentType==filetype)})
            
                if(tempSupportingDocs.length>0){
                    const filesIndices = [];
                    const filesRotation = [];
                    for(const supportingDoc of tempSupportingDocs){
                        bodyFormData.append('files',supportingDoc['file']);
                        filesIndices.push(fileIndex)
                        filesRotation.push(supportingDoc['imageRotation'])
                        fileIndex++;
                    }
                    docType.push({type: tempSupportingDocs[0]['documentType'], files: filesIndices, rotations:filesRotation})
                }
            }
            
            docType.push({type:"FPO"})
            
            const docTypeJson = JSON.stringify(docType);
            bodyFormData.append('documents', docTypeJson);

            
            let url = "";
            if (this.includesGuidedPathway()){
                url = "/efiling/"+this.id+"/submit/";
            } else {
                url = "/efiling/"+this.id+"/submit/?standalone=true"; 
            }
            
            const header = {
                responseType: "json",
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/json"                  
                }
            }
            
            this.$http.post(url, bodyFormData, header)
            .then(res => {

                if(res?.data?.message=="success")
                {
                    this.generateUrl(res.data.redirectUrl)                   
                }
            }, err => {
                this.error = err.response.data.message;
                this.submissionInProgress = false;
            });         
             
        }
        
        public generateUrl(eFilingUrl) {            
            // redirect user to the generated url
            location.replace(eFilingUrl);        
        }      

        public removeDocument(index) {
            this.supportingDocuments.splice(index, 1);           
        }
        
        public addDocument() {
            this.selectedSupportingDocumentState = this.supportingFile? true:false;
            this.selectedDocumentTypeState = this.fileType.length>0? true: false;

            if (this.supportingFile && this.fileType.length>0) {

                this.showTypeOfDocuments = false;

                const supportingdocuments = this.supportingDocuments 
                const typeIndex =  this.supportingDocuments[this.supportingDocuments.length-1]?this.supportingDocuments[this.supportingDocuments.length-1].typeIndex:[]
                if(!typeIndex.includes(this.fileType))
                    typeIndex.push(this.fileType)
                
                for(const supportingfile of this.supportingFile){
               
                    const newFile = {
                        "fileName": Vue.filter('cleanFileName')(supportingfile.name),
                        "file": supportingfile,
                        "documentType": this.fileType,
                        "image": URL.createObjectURL(supportingfile),
                        "imageRotation": 0,
                        "typeIndex":typeIndex
                    }
                    supportingdocuments.push(newFile);
                }

                this.UpdateSupportingDocuments(supportingdocuments);
                this.supportingFile = null;
                this.fileType = "";
                Vue.nextTick(()=>{
                    const el = document.getElementById('drop-area');
                    if(el) el.scrollIntoView();
                })
            }
        }

        public extractInfo(){

            this.affIsExemptGuidedPathway = false;
            this.gaIsExemptGuidedPathway = false;
            this.apsIsExemptGuidedPathway = false;
            this.apspIsExemptGuidedPathway = false;
            this.csvIsExemptGuidedPathway = false;
            this.fsIsExemptGuidedPathway = false;
            this.requiresEfsp = false;
            this.requiresGaEfsp = false;
            this.requiresApsEfsp = false;
            this.requiresApspEfsp = false;
            this.requiresCsvEfsp = false;
            this.requiresFsEfsp = false;

            let location = this.applicationLocation
            if(!this.applicationLocation) location = this.userLocation;

            this.applicantLocation = this.locationsInfo.filter(loc => {if (loc.name == location) return true})[0]              
           
            const otherFormsStepResults = this.steps[this.stPgNo.OTHER._StepNo].result;  
            this.eFiling = otherFormsStepResults?.otherFormsSurvey?.data?.filingMethod == 'eFile'; 
            this.requiredDocumentLists = [];

            const includesOtherForms = this.steps[this.stPgNo.GETSTART._StepNo].result?.otherForms;
            const completeOtherFormsPageResults = this.steps[this.stPgNo.OTHER._StepNo].result?.completeOtherFormsSurvey?.data;
            const selectedFormInfoList = completeOtherFormsPageResults?.selectedFormInfoList?completeOtherFormsPageResults.selectedFormInfoList:[];

            const rejectedFormTypesList = this.rejectedFormsList.map(form => form.type)

            if (includesOtherForms && selectedFormInfoList.length>0){

                for (const selectedForm of selectedFormInfoList){                
                    if (selectedForm.manualState || (selectedForm.formName=="Notice of Discontinuance" && this.ndtIsExemptGuidedPathway())){                       
                        const name = Vue.filter('getFullOrderName')(selectedForm.pathwayName, '');
                        const pdfType = Vue.filter('getPathwayPdfType')(selectedForm.pathwayName, '');
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes(pdfType)) continue
                        
                        this.requiredDocumentLists.push({description: name, type: pdfType});
                        this.determineEfspPdfRequired(selectedForm);                       
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Affidavit – General"){   
                        this.determineAffGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('AFF')) continue
                        
                        if (this.affIsExemptGuidedPathway)
                            this.requiredDocumentLists.push({description: 'Affidavit – General', type: 'AFF'});    
                        
                        if (this.requiresEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit – General', type: 'EFSP'});
                        }
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Guardianship Affidavit"){   
                        this.determineGaGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('GA')) continue
                        
                        if (this.gaIsExemptGuidedPathway)
                            this.requiredDocumentLists.push({description: 'Guardianship Affidavit', type: 'GA'});    
                        
                        if (this.requiresGaEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Guardianship Affidavit', type: 'EFSP'});
                        }
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Affidavit of Personal service"){   
                        this.determineApsGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('APS')) continue
                        
                        if (this.apsIsExemptGuidedPathway)
                            this.requiredDocumentLists.push({description: 'Affidavit of Personal service', type: 'APS'});    
                        
                        if (this.requiresApsEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit of Personal service', type: 'EFSP'});
                        }
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Affidavit of Personal Service of Protection Order"){   
                        this.determineApspGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('APSP')) continue
                        
                        if (this.apspIsExemptGuidedPathway)
                            this.requiredDocumentLists.push({description: 'Affidavit of Personal Service of Protection Order', type: 'APSP'});    
                        
                        if (this.requiresApspEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit of Personal Service of Protection Order', type: 'EFSP'});
                        }
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Certificate of Service"){   
                        this.determineCsvGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('CSV')) continue
                        
                        if (this.csvIsExemptGuidedPathway)
                            this.requiredDocumentLists.push({description: 'Certificate of Service', type: 'CSV'});    
                        
                        if (this.requiresCsvEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Certificate of Service', type: 'EFSP'});
                        }
                    } else if (selectedForm.pathwayState && selectedForm.formName=="Financial Statement"){   
                        this.determineFsGuidedPathway(selectedForm);
                        
                        if(this.rejectedPathway && !rejectedFormTypesList.includes('FS')) continue
                         
                        if (this.fsIsExemptGuidedPathway){
                            this.requiredDocumentLists.push({description: 'Financial Statement', type: 'FS'}); 
                            if(this.steps[this.stPgNo.FS._StepNo].result?.disclosureInformationFSSurvey?.data){
                                const disclosureData = this.steps[this.stPgNo.FS._StepNo].result.disclosureInformationFSSurvey.data
                                this.determineFsAttachments(disclosureData);
                            }
                        }                               
                        
                        if (this.requiresFsEfsp){
                            this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Financial Statement', type: 'EFSP'});
                        }
                    }                  
                }
                setTimeout(() => this.updateSubmittedPdf(),50)
            }           

        }

        public includesGuidedPathway(){

            const completeOtherFormsPageResults = this.steps[this.stPgNo.OTHER._StepNo].result?.completeOtherFormsSurvey?.data;

            const selectedFormInfoList = completeOtherFormsPageResults?.selectedFormInfoList?completeOtherFormsPageResults.selectedFormInfoList:[];

            let includesGuided = false;
            for (const selectedForm of selectedFormInfoList){
                
                if (selectedForm.pathwayExists && selectedForm.pathwayState){
                    includesGuided = true;
                    break;
                }            
            }
            return includesGuided;
        } 
        
        public ndtIsExemptGuidedPathway(){

            let ndtRequiresSignature = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'NDT')})
            if (index >=0){
                ndtRequiresSignature = existingOrdersInfo[index].doNotIncludePdf;
            } 

            const completeOtherFormsPageResults = this.steps[this.stPgNo.OTHER._StepNo].result?.completeOtherFormsSurvey?.data;
            const selectedFormInfoList = completeOtherFormsPageResults?.selectedFormInfoList?completeOtherFormsPageResults.selectedFormInfoList:[];

            for (const selectedForm of selectedFormInfoList){                
                if (selectedForm.pathwayExists && selectedForm.pathwayState && selectedForm.formName=="Notice of Discontinuance" && ndtRequiresSignature){
                    return true
                }            
            }
            return false;
        } 

        public determineEfspPdfRequired(selectedForm){
//TODO: add all pathways that require EFSP
            if(this.steps[this.stPgNo.OTHER._StepNo].result?.completeOtherFormsSurvey?.data){
                const completeOtherFormsData = this.steps[this.stPgNo.OTHER._StepNo].result.completeOtherFormsSurvey.data;
                if(completeOtherFormsData.requiresEFSP){

                    if(selectedForm.formName=="Guardianship Affidavit"){
                        this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Guardianship Affidavit', type: 'EFSP'});
                    } else if(selectedForm.formName=="Affidavit – General"){
                        this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit – General', type: 'EFSP'});
                    } else if(selectedForm.formName=="Affidavit of Personal service"){
                        this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit of Personal service', type: 'EFSP'});
                    } else if(selectedForm.formName=="Affidavit of Personal Service of Protection Order"){
                        this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Affidavit of Personal Service of Protection Order', type: 'EFSP'});
                    } else if(selectedForm.formName=="Certificate of Service"){
                        this.requiredDocumentLists.push({description: 'Electronic Filing Statement - Certificate of Service', type: 'EFSP'});
                    }
                }
            }            

        }   
        
        public determineAffGuidedPathway(selectedForm){

            let requiresAff = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'AFF')})
            if (index >=0 && this.eFiling){
                const affFilingInfo = this.$store.state.Application.steps[this.stPgNo.AFF._StepNo].result?.filingAffSurvey?.data;              
                requiresAff = affFilingInfo?.sworn?true:false;
                requiresEfsp = affFilingInfo?.sworn == 'y';
            }  
                   
            if (selectedForm.pathwayExists){
                this.affIsExemptGuidedPathway = requiresAff;
                this.requiresEfsp = requiresEfsp;
            } 
            
        }      

        public determineGaGuidedPathway(selectedForm){

            let requiresGa = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'GA')})
            if (index >=0 && this.eFiling){
                const gaFilingInfo = this.$store.state.Application.steps[this.stPgNo.GA._StepNo].result?.filingGaSurvey?.data;              
                requiresGa = gaFilingInfo?.sworn?true:false;
                requiresEfsp = gaFilingInfo?.sworn == 'y';
            } 
                   
            if (selectedForm.pathwayExists){
                this.gaIsExemptGuidedPathway = requiresGa;
                this.requiresGaEfsp = requiresEfsp;
            } 
        } 

        public determineApsGuidedPathway(selectedForm){
            let requiresAps = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'APS')})
            if (index >=0 && this.eFiling){                            
                requiresAps = this.eFiling;
                requiresEfsp = this.eFiling;
            } 
                
            if (selectedForm.pathwayExists){
                this.apsIsExemptGuidedPathway = requiresAps;
                this.requiresApsEfsp = requiresEfsp;
            } 
        }

        public determineApspGuidedPathway(selectedForm){

            let requiresApsp = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'APSP')})
            if (index >=0 && this.eFiling){                             
                requiresApsp = this.eFiling;
                requiresEfsp = this.eFiling;
            } 
                
            if (selectedForm.pathwayExists){
                this.apspIsExemptGuidedPathway = requiresApsp;
                this.requiresApspEfsp = requiresEfsp;
            } 
        }

        public determineCsvGuidedPathway(selectedForm){

            let requiresCsv = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'CSV')})
            
            if (index >=0 && this.eFiling){                             
                requiresCsv = this.eFiling;
                requiresEfsp = this.eFiling;
            } 
                
            if (selectedForm.pathwayExists){
                this.csvIsExemptGuidedPathway = requiresCsv;
                this.requiresCsvEfsp = requiresEfsp;
            } 
        }

        public determineFsAttachments(disclosureData: disclosureInformationFSDataInfoType){

            if(disclosureData.incomeAcknowledgement){

                this.requiredDocumentLists.push(
                    {
                        description: 'Your personal income tax return and related schedules for each of the 3 most recent taxation years', 
                        type: 'FS'
                    });
                this.requiredDocumentLists.push(
                    {
                        description: 'Every Notice of Assessment and Reassessment issued by Canada Revenue Agency for each of the 3 most recent taxation years', 
                        type: 'FS'
                    });
            }

            if (disclosureData.incomeProofAcknowledgement && this.steps[this.stPgNo.FS._StepNo].result?.incomeInformationSurvey?.data?.incomeAmounts) {
                const incomeData = this.steps[this.stPgNo.FS._StepNo].result?.incomeInformationSurvey.data.incomeAmounts;
                for(const incomeType of incomeData) {
                    if(incomeType.income){
                        const incomeName = incomeType.incomeName;
                        let docName = '';
                        if(incomeName == "employee")
                            docName = "Your most recent pay stub or statement of earnings, or a letter from my employer stating my salary and/or wages";
                        else if(incomeName == "EI")
                            docName = "Your most recent employment insurance benefit statement and record of employment";
                        else if(incomeName == "WCB")
                            docName = "Your most recent worker’s compensation benefit statement";
                        else if(incomeName == "investment")
                            docName = "Your most recent interest and investment statement";
                        else if(incomeName == "pension")
                            docName = "Your most recent pension income statement";
                        else if(incomeName == "govAssist")
                            docName = "Your most recent government assistance statement";
                        else if(incomeName == "selfEmployed")
                            docName = "My self-employment income for the three most recent taxation years";
                        else if(incomeName == "trust")
                            docName = "Your trust settlement agreement and the trust’s three most recent financial statements";
                        else if(incomeName == "partnership")
                            docName = "Confirmation of my income and draw from, and capital in, a partnership, for the three most recent taxation years";                            
                        else if(incomeName == "other")
                            docName = "Proof of other income: "+ (disclosureData.otherIncomeProofDocs?disclosureData.otherIncomeProofDocs:'');

                        this.requiredDocumentLists.push(
                            {
                                description: docName, 
                                type: 'FS'
                            });                        

                    }                        
                }

                if(disclosureData.corporation == "Yes"){
                    const corpDocDescription = "My corporate income for the three most recent taxation years";
                    this.requiredDocumentLists.push(
                            {
                                description: corpDocDescription, 
                                type: 'FS'
                            });
                }
                         
            }
        }

        public determineFsGuidedPathway(selectedForm){

            let requiresFs = false;
            let requiresEfsp = false;

            const existingOrdersInfo = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo].result?.existingOrders;
            const index = existingOrdersInfo.findIndex(order=>{return(order.type == 'FS')})
            if (index >=0 && this.eFiling){
                const fsFilingInfo = this.$store.state.Application.steps[this.stPgNo.FS._StepNo].result?.filingFsSurvey?.data;              
                requiresFs = fsFilingInfo?.sworn?true:false;
                requiresEfsp = fsFilingInfo?.sworn == 'y';
            } 
                
            if (selectedForm.pathwayExists){
                this.fsIsExemptGuidedPathway = requiresFs;
                this.requiresFsEfsp = requiresEfsp;
            } 
    }

        public navigateToGuide(){
            Vue.filter('scrollToLocation')("pdf-guide");
        } 
        
        public downloaded(){
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);
        }
        
        public checkErrorOnPages(){

            const stepsArr = _.range(0, Object.keys(this.stPgNo).length)  
            const optionalLabels = ["File", "Filing Options", "Next Steps", "Review and Print", "Review and Save", "Review and Submit"]
            for(const stepIndex of stepsArr){
                const step = this.$store.state.Application.steps[stepIndex]
                if(step.active){
                    for(const page of step.pages){
                        // console.log(step.id +'-'+ page.key)

                        if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                            this.$store.commit("Application/setCurrentStep", step.id);
                            this.$store.commit("Application/setCurrentStepPage", {currentStep: step.id, currentPage: page.key });                        
                            return false;
                        }
                    }
                }            
            }
            return true;        
        }

    }
